module.exports = __webpack_public_path__ + "img/AUTO_DROIT_IMAGE_ACTIVE.5523c4cb.svg";